import script from "./AudioField.vue?vue&type=script&lang=js"
export * from "./AudioField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/crynobone/Projects/laravel/nova/aries/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"AudioField.vue"]])

export default __exports__